import type { EventCategory, VideoPlatform, Duration } from "@/types";

export const EVENT_CATEGORIES: EventCategory[] = [
  {
    id: "interview", label: "Interview", icon: "\u{1F4CB}", color: "#7C3AED", desc: "Schedule candidate interviews with smart panel matching",
    subcategories: [
      { id: "technical", label: "Technical", icon: "\u{1F4BB}", ids: ["3", "4", "5"], defaultDur: 60, desc: "Coding, system design, architecture" },
      { id: "culture", label: "Culture Fit", icon: "\u{1F91D}", ids: ["1", "6"], defaultDur: 45, desc: "Values alignment, team fit" },
      { id: "leadership", label: "Leadership", icon: "\u{1F451}", ids: ["1", "2"], defaultDur: 60, desc: "VP+ candidate evaluation" },
      { id: "product", label: "Product", icon: "\u{1F4E6}", ids: ["8", "9"], defaultDur: 45, desc: "Product sense, strategy" },
      { id: "final", label: "Final Round", icon: "\u2B50", ids: ["1", "2", "3"], defaultDur: 60, desc: "Executive sign-off round" },
      { id: "screening", label: "Phone Screen", icon: "\u{1F4DE}", ids: ["7"], defaultDur: 30, desc: "Initial candidate screening" },
    ],
  },
  {
    id: "meeting", label: "Meeting", icon: "\u{1F91D}", color: "#10b981", desc: "Team syncs, stand-ups, and collaborative sessions",
    subcategories: [
      { id: "one_on_one", label: "1-on-1", icon: "\u{1F465}", ids: [], defaultDur: 30, desc: "Manager-report check-in" },
      { id: "touchpoint", label: "Touch Point", icon: "\u{1F4CD}", ids: [], defaultDur: 15, desc: "Quick sync or status update" },
      { id: "standup", label: "Stand-up", icon: "\u26A1", ids: ["3", "4", "5"], defaultDur: 15, desc: "Daily agile stand-up" },
      { id: "brainstorm", label: "Brainstorm", icon: "\u{1F4A1}", ids: [], defaultDur: 60, desc: "Ideation and creative session" },
      { id: "all_hands", label: "All Hands", icon: "\u{1F3E2}", ids: ["1", "2"], defaultDur: 60, desc: "Company-wide update" },
      { id: "sprint_plan", label: "Sprint Planning", icon: "\u{1F3AF}", ids: ["3", "4", "8", "9"], defaultDur: 60, desc: "Sprint kickoff and planning" },
    ],
  },
  {
    id: "review", label: "Review", icon: "\u{1F50D}", color: "#f59e0b", desc: "Performance, code, and design review sessions",
    subcategories: [
      { id: "perf_review", label: "Performance", icon: "\u{1F4C8}", ids: ["1", "2", "6"], defaultDur: 45, desc: "Quarterly/annual performance review" },
      { id: "code_review", label: "Code Review", icon: "\u{1F4BB}", ids: ["3", "4", "5"], defaultDur: 30, desc: "Pull request or architecture review" },
      { id: "design_review", label: "Design Review", icon: "\u{1F3A8}", ids: ["8", "9", "3"], defaultDur: 45, desc: "UX/product design critique" },
      { id: "retro", label: "Retrospective", icon: "\u{1F504}", ids: ["3", "4", "5"], defaultDur: 60, desc: "Sprint or project retrospective" },
      { id: "360_feedback", label: "360 Feedback", icon: "\u{1F4AC}", ids: ["6"], defaultDur: 30, desc: "Multi-rater feedback session" },
    ],
  },
  {
    id: "other", label: "Other", icon: "\u2699\uFE0F", color: "#8b5cf6", desc: "Client calls, training, demos, and custom events",
    subcategories: [
      { id: "client_call", label: "Client Call", icon: "\u{1F4DE}", ids: ["2", "8"], defaultDur: 30, desc: "External client meeting" },
      { id: "training", label: "Training", icon: "\u{1F393}", ids: ["6"], defaultDur: 60, desc: "Workshop or learning session" },
      { id: "onboarding", label: "Onboarding", icon: "\u{1F680}", ids: ["6", "7"], defaultDur: 45, desc: "New hire orientation" },
      { id: "demo", label: "Demo / Showcase", icon: "\u{1F4FA}", ids: ["8", "9", "3"], defaultDur: 30, desc: "Product or feature demo" },
      { id: "custom", label: "Custom", icon: "\u270F\uFE0F", ids: [], defaultDur: 30, desc: "Build your own event" },
    ],
  },
];

export const VIDEO_PLATFORMS: VideoPlatform[] = [
  { id: "teams", label: "Microsoft Teams", icon: "\u{1F4BB}", color: "#6264a7" },
  { id: "meet", label: "Google Meet", icon: "\u{1F7E2}", color: "#00897b" },
  { id: "zoom", label: "Zoom", icon: "\u{1F535}", color: "#2d8cff" },
  { id: "webex", label: "Webex", icon: "\u{1F7E1}", color: "#07c160" },
  { id: "custom", label: "Custom Link", icon: "\u{1F517}", color: "#A78BFA" },
  { id: "none", label: "No Video", icon: "\u{1F6AB}", color: "#6b7280" },
];

export const DURATIONS: Duration[] = [
  { mins: 15, label: "15 min" },
  { mins: 30, label: "30 min" },
  { mins: 45, label: "45 min" },
  { mins: 60, label: "1 hour" },
];
